import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useContext, useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import PlayersListByTeam from "./PlayersListByTeam";
import { ShopContext } from "../../Context/ShopContext";
import LiveMatchControl from "./LiveMatchControl";
import PlayingEleven from "./PlayingEleven";
import { io } from 'socket.io-client';
import CompletedMatch from "./CompletedMatch";
import { Link } from "react-router-dom";

const SOCKET_SERVER_URL = 'https://yblapis.ganpatigroupbharat.com';
// const SOCKET_SERVER_URL = 'http://localhost:8000';


const MatchStatusById = () => {
    const params = useParams();
    const matchId = params.id;

    const {
        isDisabled, setIsDisabled
    } = useContext(ShopContext);

    const [matches, setMatches] = useState({});
    const [loading, setLoading] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [teams, setTeams] = useState([]);
    const [players, setPlayers] = useState([]);
    const [innings, setInnings] = useState([]);
    const [playingElevenMatch, setPlayingElevenMatch] = useState([]);
    const [battingTeamPlayers, setBattingTeamPlayers] = useState([]);
    const [bowlingTeamPlayers, setBowlingTeamPlayers] = useState([]);
    const [scorecard, setScorecard] = useState(null);
    const [totalRuns, setTotalRuns] = useState(0);
    const [totalBalls, setTotalBalls] = useState(0);
    const [totalOvers, setTotalOvers] = useState(0);
    const [currentInning, setCurrentInning] = useState();
    const [striker, setStriker] = useState(null);
    const [nonStriker, setNonStriker] = useState(null);
    const [currentBowler, setCurrentBowler] = useState(null);
    const [priviousBowler, setPriviousBowler] = useState(null);
    const [showOutOptions, setShowOutOptions] = useState(false);
    const [isStrikerAvaiable, setIsStrikerAvaiable] = useState(false);
    const [nonStrikerAvaiable, setNonIsStrikerAvaiable] = useState(false);
    const [currentTotalOver, setCurrentTotalOver] = useState();
    const [isRunOut, setIsRunOut] = useState(false)
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    const [teamAPlayers, setTeamAPlayers] = useState([]);
    const [teamBPlayers, setTeamBPlayers] = useState([]);

    const firstInnings = innings.find(i => i.inning_no === 1);
    const secondInnings = innings.find(i => i.inning_no === 2);


    const [formData, setFormData] = useState({
        id: matchId,
        toss_winner_id: "",
        elected_to: "",
        result: "",
    });

    const [isCurrentOver, setIsCurrentOver] = useState(null)

    useEffect(() => {
        const currentOver = currentBowler?.overs;  // Example: 2.5, 3.0, 1.4, etc.
        const isCurrentOverRunning = currentOver && currentOver % 1 !== 0;
        setIsCurrentOver(isCurrentOverRunning);

    }, [currentBowler, setIsCurrentOver])

    useEffect(() => {
        const currentInningData = scorecard?.innings.find(inn => inn.innstatus === "in_progress") || innings[0];
        setCurrentInning(currentInningData)
    }, [scorecard, innings])

    useEffect(() => {
        // Filter the batting array to find the striker and non-striker
        const isStrikerAvaiable = currentInning?.batting?.filter(i => i.position === 'striker');
        const isNonStrikerAvaiable = currentInning?.batting?.filter(i => i.position === 'non-striker');

        // Set state to true if the filtered arrays have elements (i.e., striker and non-striker are available)
        setIsStrikerAvaiable(isStrikerAvaiable?.length > 0); // true if there is a striker
        setNonIsStrikerAvaiable(isNonStrikerAvaiable?.length > 0); // true if there is a non-striker

    }, [currentInning]); // Dependency on currentInning

    const handleWicket = () => {
        setShowOutOptions(true);
    };

    // ✅ Fetch match details
    const fetchMatches = useCallback(async () => {
        if (!matchId) return;
        try {
            const res = await axios.get(`${baseurl}${API_URL.getMatchById}?id=${matchId}`);
            if (res.status === 200) {
                const matchData = res.data?.data?.[0] || res.data?.data || {};
                setMatches(matchData);

                setFormData((prev) => ({
                    ...prev,
                    id: matchData.id || matchId,
                    teamA_id: matchData.teamA_id,
                    teamB_id: matchData.teamB_id,
                    toss_winner_id: matchData.toss_winner_id || "",
                    elected_to: matchData.elected_to || "",
                }));
            }
        } catch (err) {
            toast.error("Failed to load match details");
        }
    }, [matchId]);

    useEffect(() => {
        fetchMatches();
    }, [fetchMatches]);

    // ✅ Fetch Teams
    const fetchTeams = async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (res?.data?.status === true) setTeams(res.data.data);
        } catch {
            toast.error("Failed to load teams");
        }
    };

    useEffect(() => {
        fetchTeams();
    }, []);

    // ✅ Fetch Players
    const fetchPlayers = async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getAllPlayers}`);
            if (res?.data?.status === true) setPlayers(res.data.data);
        } catch {
            toast.error("Failed to load players");
        }
    };

    useEffect(() => {
        fetchPlayers();
    }, []);

    // ✅ Fetch innings (to get inning_id dynamically)
    const fetchInnings = useCallback(async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getMatchInningsByMatchId}?matchId=${matchId}`);
            if (res?.data?.status === true) {
                setInnings(res.data.data);
            }
        } catch {
            console.error("Failed to fetch innings");
        }
    }, [matchId]);

    useEffect(() => {
        if (matchId && matches.status === "live" && matches.toss_winner_id) fetchInnings();
    }, [matchId, matches.status, matches.toss_winner_id, fetchInnings]);

    const fetchPlayingElevenByMatch = useCallback(async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getPlayingElevenByMatch}?matchId=${matchId}`);
            if (res?.data?.status === true) {
                setPlayingElevenMatch(res.data.data);
            }
        } catch {
            console.error("Failed to fetch innings");
        }
    }, [matchId]);

    useEffect(() => {
        if (matchId) fetchPlayingElevenByMatch();
    }, [matchId, matches.status, fetchPlayingElevenByMatch]);

    // ✅ Update Toss & Create Innings
    const updateTossResult = async () => {
        try {
            const { id, toss_winner_id, elected_to, result, teamA_id, teamB_id } = formData;

            if (!id || !toss_winner_id || !elected_to) {
                toast.error("Please fill all required fields.");
                return;
            }

            const matchIdInt = parseInt(id);
            const tossWinnerTeam = parseInt(toss_winner_id);
            const teamA = parseInt(teamA_id);
            const teamB = parseInt(teamB_id);

            const tossRes = await axios.put(`${baseurl}${API_URL.updateToss}`, {
                id: matchIdInt,
                toss_winner_id: tossWinnerTeam,
                elected_to,
                result,
            });

            if (tossRes.data.isSuccess !== 1) {
                toast.error(tossRes.data.message || "Toss update failed");
                return;
            }

            const opponentTeam = tossWinnerTeam === teamA ? teamB : teamA;

            let inningsData = [];
            if (elected_to === "bat") {
                inningsData = [
                    { match_id: matchIdInt, batting_team_id: tossWinnerTeam, bowling_team_id: opponentTeam, inning_no: 1 },
                    { match_id: matchIdInt, batting_team_id: opponentTeam, bowling_team_id: tossWinnerTeam, inning_no: 2 },
                ];
            } else {
                inningsData = [
                    { match_id: matchIdInt, batting_team_id: opponentTeam, bowling_team_id: tossWinnerTeam, inning_no: 1 },
                    { match_id: matchIdInt, batting_team_id: tossWinnerTeam, bowling_team_id: opponentTeam, inning_no: 2 },
                ];
            }

            for (const inning of inningsData) {
                await axios.post(`${baseurl}${API_URL.saveMatchInnings}`, inning);
            }

            toast.success("Toss updated successfully!");
            fetchMatches();
            fetchInnings();
            setIsFormOpen(false);
            localStorage.setItem('toss', true);

            await axios.put(`${baseurl}${API_URL.updateMatchStatus}`, {
                matchId: matchIdInt,
                status: 'live'
            });

        } catch (error) {
            console.error("Error updating toss:", error);
            toast.error("Something went wrong while updating toss/result.");
        }
    };

    // ✅ Start Match Logic
    // ✅ Start Match Logic (Final)
    const onStartMatch = async () => {
        try {
            if (!striker || !nonStriker || !currentBowler) {
                toast.error("Please select striker, non-striker, and bowler!");
                return;
            }

            // 🧠 Get active inning_id
            const activeInning = innings.find((inn) => inn.inning_no === 1);
            const inning_id = activeInning ? activeInning.id : null;

            if (!inning_id) {
                toast.error("Inning ID not found. Please check innings data.");
                return;
            }

            // Update the inning status to 'completed'
            await axios.put(`${baseurl}${API_URL.updateInningsStatus}`, {
                inning_id: inning_id,
                innstatus: 'in_progress'
            });

            // ✅ STEP 1: Batting Scorecards for Striker & Non-Striker
            const battingScorecards = [
                {
                    match_id: matchId,
                    inning_id,
                    player_id: striker.playerId || striker.playersId,
                    position: "striker",
                    runs: 0,
                    balls: 0,
                    fours: 0,
                    sixes: 0,
                    strike_rate: 0,
                    how_out: "",
                    bowler_id: 0,
                    fielder_id: 0,
                },
                {
                    match_id: matchId,
                    inning_id,
                    player_id: nonStriker.playerId || nonStriker.playersId,
                    position: "non-striker",
                    runs: 0,
                    balls: 0,
                    fours: 0,
                    sixes: 0,
                    strike_rate: 0,
                    how_out: "",
                    bowler_id: 0,
                    fielder_id: 0,
                },
            ];

            for (const player of battingScorecards) {
                if (!player.match_id || !player.inning_id || !player.player_id) {
                    console.error("Invalid batting scorecard:", player);
                    toast.error("Missing match_id, inning_id, or player_id!");
                    return;
                }
                await axios.post(`${baseurl}${API_URL.saveBattingScorecard}`, player);
            }

            // ✅ STEP 2: Bowling Scorecard for Current Bowler
            const bowlingScorecard = {
                match_id: matchId,
                inning_id,
                player_id: currentBowler.playerId || currentBowler.playersId,
                is_current_bowler: "yes", // ✅ Now explicit "yes" for selected bowler
                overs: 0,
                maidens: 0,
                runs_conceded: 0,
                wickets: 0,
                economy: 0,
            };

            await axios.post(`${baseurl}${API_URL.saveBowlingScorecard}`, bowlingScorecard);

            // ✅ STEP 3: Update Match Start Status in matches table
            await axios.put(`${baseurl}${API_URL.updateMatchStartStatus}`, {
                matchId,
                isStart: true,
            });

            toast.success("🚀 Match started successfully!");
            fetchMatches();
        } catch (error) {
            console.error("❌ Error starting match:", error);
            toast.error("Failed to start match!");
        }
    };


    // ✅ Find team names for toss result display
    const tossWinnerName = teams.find((t) => t.id === matches.toss_winner_id)?.teamName;
    const electedText = matches.elected_to ? (matches.elected_to === "bat" ? "bat" : "bowl") : "";

    useEffect(() => {
        if (!playingElevenMatch || !matches) return;

        let battingTeamId, bowlingTeamId;

        // if (matches.elected_to === "bat") {
        // battingTeamId = currentInning?.batting_team_id;
        battingTeamId =
            currentInning?.batting_team_id === matches.teamA_id
                ? matches.teamA_id
                : matches.teamB_id;
        bowlingTeamId =
            currentInning?.bowling_team_id === matches.teamB_id
                ? matches.teamB_id
                : matches.teamA_id;
        // } else if (matches.elected_to === "bowl") {
        //     bowlingTeamId = matches.toss_winner_id;
        //     battingTeamId =
        //         matches.toss_winner_id === matches.teamA_id
        //             ? matches.teamB_id
        //             : matches.teamA_id;
        // }

        const battingTeam = playingElevenMatch
            .filter((p) => Number(p.teamId) === Number(battingTeamId))
            .map((p) => ({
                playerId: p.playerId,
                playerName: p.playerName,
                playerRole: p.playerRole,
                teamName: p.teamName,
            }));

        const bowlingTeam = playingElevenMatch
            .filter((p) => Number(p.teamId) === Number(bowlingTeamId))
            .map((p) => ({
                playerId: p.playerId,
                playerName: p.playerName,
                playerRole: p.playerRole,
                teamName: p.teamName,
            }));

        setBattingTeamPlayers(battingTeam);
        setBowlingTeamPlayers(bowlingTeam);

        if (matches?.isStart === 0 || matches?.isStart === null || matches?.isStart === undefined) {
            // 🏏 Set default players
            if (battingTeam.length > 0) {
                setStriker(battingTeam[0]);
                if (battingTeam.length > 1) setNonStriker(battingTeam[1]);
            }

            if (bowlingTeam.length > 0) {
                setCurrentBowler(bowlingTeam[bowlingTeam.length - 1]);
            }
        }

    }, [playingElevenMatch, matches, setNonStriker, setStriker, setCurrentBowler, currentInning]);


    // Update the dropdowns with the selected striker, non-striker, and bowler
    const handleStrikerChange = (e) => {
        const player = battingTeamPlayers.find((p) => p.playerName === e.target.value);
        setStriker(player);
    };

    const handleNonStrikerChange = (e) => {
        const player = battingTeamPlayers.find((p) => p.playerName === e.target.value);
        setNonStriker(player);
    };

    const handleBowlerChange = (e) => {
        const player = bowlingTeamPlayers.find((p) => p.playerName === e.target.value);
        setCurrentBowler(player);
    };

    useEffect(() => {
        if (matches?.isStart === 1) {
            setStriker(currentInning?.batting?.find(p => p.position === "striker") || {})
            setNonStriker(currentInning?.batting?.find(p => p.position === "non-striker") || {})
            setCurrentBowler(currentInning?.bowling?.find(p => p.is_current_bowler === "yes") || {});
        }
    }, [currentInning, matches])

    // UseEffect to connect to WebSocket
    useEffect(() => {
        const socket = io(SOCKET_SERVER_URL, { transports: ['websocket'] });

        // Handle socket connection success
        socket.on('connect', () => {
            setIsSocketConnected(true);
            // console.log('WebSocket connected');
        });

        // Handle socket connection error
        socket.on('connect_error', (err) => {
            console.error('WebSocket connection error:', err);
            setIsSocketConnected(false);
            // toast.error('Failed to connect to WebSocket!');
        });

        // Subscribe to match
        socket.emit('subscribeMatch', matchId);

        // Listen for live updates
        socket.on('scorecardUpdate', (data) => {
            setScorecard(data);
        });

        // Cleanup on unmount
        return () => {
            socket.disconnect();
            setIsSocketConnected(false);
        };
    }, [matchId]);

    // if (!scorecard) return <div>Loading live score...</div>;

    const handleRunOut = (run, isWicket = false, how_out, playerId) => {
        updateLiveMatchScore(run, isWicket = false, how_out, playerId);
    }

    // console.log(currentInning,'currentInning')

    const updateLiveMatchScore = async (run, isWicket = false, how_out, playerId, isWide, isNoBall) => {
        if (isDisabled) {
            // Don't do anything if the button is disabled
            return;
        }

        if (Object.keys(striker).length === 0) {
            toast.error("Striker must be selected!");
            return;
        }

        if (Object.keys(nonStriker).length === 0) {
            toast.error("Non-Striker must be selected!");
            return;
        }

        if (Object.keys(currentBowler).length === 0) {
            toast.error("Bowler must be selected!");
            return;
        }

        setLoading(true);
        // Re-enable it after 3 seconds

        try {
            if (!striker.playerId || !nonStriker.playerId) {
                toast.error("Both Striker and Non-Striker must be selected!");
                return;
            }

            console.log(totalBalls, 'totalBalls')

            let newTotalBalls = isWide || isNoBall ? totalBalls + 0 : totalBalls + 1;
            let newTotalOvers = totalOvers;
            if (newTotalBalls >= 6) {
                newTotalBalls = 0;
                newTotalOvers += 1;
            }

            if (totalBalls + 1 === 6 && (run === 0 || run === 2 || run === 4 || run === 6)) {
                // Odd run: switch striker and non-striker
                const newStriker = nonStriker;
                const newNonStriker = striker;
                setStriker(newStriker);
                setNonStriker(newNonStriker);
                await axios.post(`${baseurl}${API_URL.updateBattingPosition}`, {
                    matchId: matchId,
                    inningId: currentInning?.id,
                    strikerId: newNonStriker.playerId,
                    nonStrikerId: newStriker.playerId
                });

                await axios.post(`${baseurl}${API_URL.updateBattingPosition}`, {
                    matchId: matchId,
                    inningId: currentInning?.id,
                    strikerId: newNonStriker.playerId,
                    nonStrikerId: newStriker.playerId
                });
            }

            if (Number(totalBalls + 1) === 1 && priviousBowler && priviousBowler.playerId) {
                await axios.post(`${baseurl}${API_URL.updateCurrentBowlingIs}`, {
                    match_id: Number(matchId),
                    inning_id: currentInning?.id,
                    player_id: priviousBowler.playerId,
                    is_current_bowler: "no"
                });
            }

            if (Number(totalBalls + 1) === Number(6)) {
                await axios.post(`${baseurl}${API_URL.updateCurrentBowlingIs}`, {
                    match_id: Number(matchId),
                    inning_id: currentInning?.id,
                    player_id: currentBowler.playerId,
                    is_current_bowler: "privious"
                });
                setPriviousBowler(currentBowler);
            }

            const newTotalRuns = totalRuns + run;
            const wickets = isWicket ? 1 : 0;

            // Handle wide ball separately
            let adjustedRun = run;
            let adjustedBalls = 1;
            if (isWide || isNoBall) {
                adjustedRun = 1; // Wide ball gets 1 run
                adjustedBalls = 0; // Wide ball doesn't count towards balls
                isWicket = false;  // Ensure isWicket is false for wide balls
            }

            // Update striker and non-striker based on runs and wickets
            if (isWicket) {
                const newStriker = nonStriker;
                const newNonStriker = striker;
                setStriker(newStriker);
                setNonStriker(newNonStriker);

                // Sending data for Fall of Wicket
                await axios.post(`${baseurl}${API_URL.saveFallOfWickets}`, {
                    match_id: matchId,
                    inning_id: currentInning?.id,
                    player_id: playerId || striker.playerId,
                    team_score: totalRuns,
                });

            } else if (run % 2 !== 0 && (!isWide && !isNoBall)) {
                // Odd run: switch striker and non-striker
                const newStriker = nonStriker;
                const newNonStriker = striker;
                setStriker(newStriker);
                setNonStriker(newNonStriker);
                await axios.post(`${baseurl}${API_URL.updateBattingPosition}`, {
                    matchId: matchId,
                    inningId: currentInning?.id,
                    strikerId: newNonStriker.playerId,
                    nonStrikerId: newStriker.playerId
                });
            }

            await axios.post(`${baseurl}${API_URL.updateMatchScore}`, {
                matchId: matchId,
                inningId: currentInning?.id,
                total_runs: adjustedRun,
                wickets: wickets,
                overs: newTotalOvers.toFixed(1),
                playerId: playerId || striker.playerId,  // Ensure player ID is not undefined
                runs: isWide || isNoBall ? 0 : adjustedRun,
                balls: isWide || isNoBall ? 0 : adjustedBalls,
                isWicket: isWicket,
                howOut: isWicket ? how_out : null,
                bowlerId: currentBowler?.playerId || null,
                fielderId: isWicket ? currentInning?.fielder_id || null : null,
                maidens: 0,
                runsConceded: isWide || isNoBall ? 1 : adjustedRun,
                isCurrentBowler: Number(totalBalls + 1) === Number(6) ? false : true
            });

            setTotalRuns(newTotalRuns);
            setTotalBalls(newTotalBalls);
            setTotalOvers(newTotalOvers);

        } catch (error) {
            // toast.error("Something went wrong while updating score.");
            console.error(error);
        } finally {
            setLoading(false);
            setShowOutOptions(false);
            setIsRunOut(false);
        }
    };

    const disableButtonFor3Seconds = () => {
        setIsDisabled(true);

        // Re-enable the button after 3 seconds
        setTimeout(() => {
            setIsDisabled(false);
        }, 3000); // 3000ms = 3 seconds
    };


    // Add batsman (either striker or non-striker) to the scorecard
    const addNewBatmans = async (e, position) => {
        const playerName = e.target.value; // Get the selected player from the dropdown
        const player = battingTeamPlayers.find(p => p.playerName === playerName); // Find the player based on name

        if (!player || !player.playerId) {
            toast.error("Player selection error.");
            return;
        }

        // Fetch the active inning_id
        const activeInning = innings.find((inn) => inn.inning_no === currentInning?.inning_no);
        const inning_id = activeInning ? activeInning.id : null;

        if (!inning_id) {
            toast.error("Inning ID not found.");
            return;
        }

        // Add the selected player to the batting scorecard
        await axios.post(`${baseurl}${API_URL.saveBattingScorecard}`, {
            match_id: matchId,
            inning_id,
            player_id: player.playerId,
            position: position, // This could either be 'striker' or 'non-striker'
            runs: 0,
            balls: 0,
            fours: 0,
            sixes: 0,
            strike_rate: 0,
            how_out: "",
            bowler_id: 0,
            fielder_id: 0,
        });

        // Update the parent component state (striker or non-striker)
        if (position === "striker") {
            setStriker(player);
        } else if (position === "non-striker") {
            setNonStriker(player);
        }

        toast.success(`${position} updated: ${playerName}`);
    };

    const changeBowler = async (nextBowlerId) => {

        const activeInning = innings.find((inn) => inn.inning_no === currentInning?.inning_no);
        const inning_id = activeInning ? activeInning.id : null;

        if (!inning_id) {
            toast.error("Inning ID not found.");
            return;
        }

        if (currentBowler && currentBowler.playerId && currentBowler.playerId !== undefined && currentBowler.playerId !== null) {
            // Proceed to update the current bowler stats
            await axios.post(`${baseurl}${API_URL.updateCurrentBowlingIs}`, {
                match_id: matchId,
                inning_id,
                player_id: currentBowler.playerId,
                is_current_bowler: "no"
            });
        }

        // Fetch the current bowler's data
        try {
            // If no data is found for the current bowler, switch to the next bowler
            const nextBowler = bowlingTeamPlayers.find(bowler => bowler.playerId !== currentBowler.playerId);

            // if (Object.keys(currentBowler).length > 0) {

            const currentBowlingData = await axios.get(`${baseurl}${API_URL.getBowlingData}?match_id=${matchId}&inning_id=${inning_id}&player_id=${nextBowlerId}`);

            // If current bowler exists, update their status to "no"
            if (currentBowlingData?.data?.bowlingData) {

                // Now update the new bowler stats
                await axios.post(`${baseurl}${API_URL.updateCurrentBowlingIs}`, {
                    match_id: matchId,
                    inning_id,
                    player_id: currentBowlingData?.data?.bowlingData?.player_id,
                    is_current_bowler: "yes"
                });
                // }
            } else {

                if (nextBowler) {
                    setCurrentBowler(nextBowler);

                    // Save the new bowler to the scorecard
                    await axios.post(`${baseurl}${API_URL.saveBowlingScorecard}`, {
                        match_id: matchId,
                        inning_id,
                        player_id: nextBowlerId,
                        is_current_bowler: "yes", // Mark this player as the current bowler
                        overs: 0, // Start the new bowler with 0 overs
                        maidens: 0,
                        runs_conceded: 0,
                        wickets: 0,
                        economy: 0,
                    });

                    // Toast message to indicate the new bowler
                    toast.success(`${nextBowler.playerName} is now the bowler.`);
                } else {
                    toast.error("No next bowler found.");
                }
            }
        } catch (error) {
            console.error("Error in changing the bowler:");
        }
    };

    // Update over and bowler logic
    const updateOverAndBowler = async () => {
        let newTotalBalls = totalBalls + 1;
        let newTotalOvers = totalOvers;

        if (newTotalBalls >= 6) {
            newTotalBalls = 0;
            newTotalOvers += 1;
            await changeBowler();  // Change the bowler after every over
        }

        // Update runs and balls
        setTotalBalls(newTotalBalls);
        setTotalOvers(newTotalOvers);

        // // Proceed to update the score
        // await updateLiveMatchScore(1);  // Call update function with dummy run (1 for now)
    };

    const endFirstInning = async () => {

        if (!currentInning || !matchId) {
            toast.error("Inning ID not found.");
            return;
        }

        try {
            const newStriker = nonStriker;
            const newNonStriker = striker;

            await axios.post(`${baseurl}${API_URL.updateBattingPositionEndInn}`, {
                matchId: matchId,
                inningId: currentInning?.id,
                strikerId: newStriker.playerId,
                nonStrikerId: newNonStriker.playerId
            });

            if (currentBowler && currentBowler.playerId && currentBowler.playerId !== undefined && currentBowler.playerId !== null) {
                // Proceed to update the current bowler stats
                await axios.post(`${baseurl}${API_URL.updateCurrentBowlingIs}`, {
                    match_id: matchId,
                    inning_id: currentInning?.id,
                    player_id: currentBowler?.playerId,
                    is_current_bowler: "no"
                });
            }

            // Update the inning status to 'completed'
            const response = await axios.put(`${baseurl}${API_URL.updateInningsStatus}`, {
                inning_id: currentInning?.id,
                innstatus: 'completed'
            });

            // if (currentInning?.inning_no === 2) {
            //     await axios.put(`${baseurl}${API_URL.updateMatchStatus}`, {
            //         matchId: matchId,
            //         status: 'completed'
            //     });

            //     await axios.put(`${baseurl}${API_URL.updateResult}`, {
            //         id: matchId,
            //         result: 'completed',
            //         winner_team_id: null
            //     });
            // }

            if (currentInning?.inning_no === 2) {

                const innings = scorecard.innings;

                const firstInnings = innings.find(i => i.inning_no === 1);
                const secondInnings = innings.find(i => i.inning_no === 2);

                let winnerTeamId = null;

                if (firstInnings && secondInnings) {
                    const runs1 = firstInnings.total_runs;
                    const runs2 = secondInnings.total_runs;

                    if (runs1 > runs2) {
                        winnerTeamId = firstInnings.batting_team_id;
                    } else if (runs2 > runs1) {
                        winnerTeamId = secondInnings.batting_team_id;
                    } else {
                        winnerTeamId = null; // match tie
                    }
                }

                // update match status
                await axios.put(`${baseurl}${API_URL.updateMatchStatus}`, {
                    matchId: matchId,
                    status: 'completed'
                });

                // update result + winner team
                await axios.put(`${baseurl}${API_URL.updateResult}`, {
                    id: matchId,
                    result: 'WON',
                    winner_team_id: winnerTeamId,
                    isStart: false
                });
            }

            if (response.status === 200) {
                toast.success("Innings End!");
            } else {
                toast.error("Failed to update inning status.");
            }

        } catch (error) {
            console.error(error);
            toast.error("An error occurred while ending the inning.");
        }
    };

    const startInning = async (inning_no) => {
        // Fetch the active inning_id
        const activeInning = innings.find((inn) => inn.inning_no === inning_no);
        const inning_id = activeInning ? activeInning.id : null;

        if (!inning_id) {
            toast.error("Inning ID not found.");
            return;
        }

        try {
            // Update the inning status to 'completed'
            const response = await axios.put(`${baseurl}${API_URL.updateInningsStatus}`, {
                inning_id: inning_id,
                innstatus: 'in_progress'
            });

            if (response.status === 200) {
                toast.success("Innings End!");
            } else {
                toast.error("Failed to update inning status.");
            }
        } catch (error) {
            console.error(error);
            toast.error("An error occurred while ending the inning.");
        }
    };

    const typeTeams = teams?.filter((item => item?.type === 'team' && (item?.id === matches?.teamA_id || item?.id === matches?.teamB_id)));

    const getMatchResultText = () => {
        if (!scorecard?.innings) return "";

        const firstInnings = scorecard.innings.find(i => i.inning_no === 1);
        const secondInnings = scorecard.innings.find(i => i.inning_no === 2);

        if (!firstInnings || !secondInnings) return "";

        const runs1 = firstInnings.total_runs;
        const runs2 = secondInnings.total_runs;

        const team1 = matches.teamA_name; // batting first
        const team2 = matches.teamB_name; // batting second

        if (runs1 > runs2) {
            const winMargin = runs1 - runs2;
            return `${team1} won the match by ${winMargin} runs 🏆`;
        }

        if (runs2 > runs1) {
            const wicketsLost = secondInnings.wickets;
            const wicketsRemaining = 10 - wicketsLost;
            return `${team2} won the match by ${wicketsRemaining} wickets 🏆`;
        }

        return "Match tied 🤝";
    };


    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <Link to={`/matches-list/${matches?.tournament_id}`} className="back_button">
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        <h4 className="mb-0">{matches?.tournamentName || "Match Details"}</h4>
                    </div>

                    {teamAPlayers.length >= 11 && teamBPlayers.length >= 11 && (
                        matches.status === "completed" ? (
                            <span className="badge bg-success fs-6">
                                {getMatchResultText()}
                            </span>
                        ) : (
                            matches.toss_winner_id && matches.isStart ? (
                                <span className="badge bg-success fs-6">
                                    🏏 {tossWinnerName} won the toss and elected to {electedText}.
                                </span>
                            ) : (
                                <button className="toss_btn" onClick={() => setIsFormOpen(true)}>
                                    Toss
                                </button>
                            )
                        )
                    )}
                </div>

                {!matches?.isPlayingEleven && matches.status === "live" && (
                    <PlayersListByTeam
                        players={players}
                        matches={matches}
                        onStartMatch={onStartMatch}
                        striker={striker}
                        setStriker={setStriker}
                        nonStriker={nonStriker}
                        setNonStriker={setNonStriker}
                        currentBowler={currentBowler}
                        setCurrentBowler={setCurrentBowler}
                        playingElevenMatch={playingElevenMatch}
                        fetchMatches={fetchMatches}
                        fetchPlayingElevenByMatch={fetchPlayingElevenByMatch}
                        fetchInnings={fetchInnings}
                        teamAPlayers={teamAPlayers} setTeamAPlayers={setTeamAPlayers}
                        teamBPlayers={teamBPlayers} setTeamBPlayers={setTeamBPlayers}
                    />
                )}

                {matches.toss_winner_id && matches?.isPlayingEleven === 1 && !matches.isStart && matches.status === "live" && matches.status !== "completed" && (
                    <PlayingEleven
                        players={players}
                        matches={matches}
                        onStartMatch={onStartMatch}
                        striker={striker}
                        nonStriker={nonStriker}
                        currentBowler={currentBowler}
                        playingElevenMatch={playingElevenMatch}
                        innings={innings}
                        fetchMatches={fetchMatches}
                        matchId={matchId}
                        handleNonStrikerChange={handleNonStrikerChange}
                        handleStrikerChange={handleStrikerChange}
                        handleBowlerChange={handleBowlerChange}
                        battingTeamPlayers={battingTeamPlayers}
                        bowlingTeamPlayers={bowlingTeamPlayers}
                    />
                )}

                {(matches.toss_winner_id && matches?.isPlayingEleven && matches.isStart === 1 && matches?.result === null) && (
                    <LiveMatchControl
                        firstInnings={firstInnings}
                        secondInnings={secondInnings}
                        scorecard={scorecard}
                        updateLiveMatchScore={updateLiveMatchScore}
                        nonStriker={nonStriker}
                        striker={striker}
                        currentBowler={currentBowler}
                        matchId={matchId}
                        battingTeamPlayers={battingTeamPlayers}
                        bowlingTeamPlayers={bowlingTeamPlayers}
                        handleStrikerChange={handleStrikerChange}
                        handleNonStrikerChange={handleNonStrikerChange}
                        addNewBatmans={addNewBatmans}
                        changeBowler={changeBowler}
                        updateOverAndBowler={updateOverAndBowler}
                        loading={loading}
                        showOutOptions={showOutOptions}
                        setShowOutOptions={setShowOutOptions}
                        isDisabled={isDisabled}
                        disableButtonFor3Seconds={disableButtonFor3Seconds}
                        isCurrentOver={isCurrentOver}
                        handleWicket={handleWicket}
                        isStrikerAvaiable={isStrikerAvaiable}
                        nonStrikerAvaiable={nonStrikerAvaiable}
                        endFirstInning={endFirstInning}
                        currentTotalOver={currentTotalOver}
                        startInning={startInning}
                        currentInning={currentInning}
                        handleRunOut={handleRunOut}
                        isRunOut={isRunOut}
                        setIsRunOut={setIsRunOut}
                    />
                )}

                {matches?.result !== null && matches.isStart === 0 && (
                    <CompletedMatch scorecard={scorecard} />
                )}

                <div className={`adminform entryform ${isFormOpen ? "open" : ""}`}>
                    <div className="closebtn">
                        <button onClick={() => setIsFormOpen(false)}>
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>

                    <div className="enForm">
                        <h5 className="mb-3 fw-bold">Update Toss & Result</h5>

                        <div className="mb-3">
                            <label className="form-label">Toss Winner</label>
                            <select
                                className="form-control"
                                value={formData.toss_winner_id}
                                onChange={(e) =>
                                    setFormData({ ...formData, toss_winner_id: e.target.value })
                                }
                            >
                                <option value="">Select Team</option>
                                {typeTeams?.map((team) => {
                                    return (
                                        <option key={team.id} value={team.id}>
                                            {team?.teamName}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Elected To</label>
                            <select
                                className="form-control"
                                value={formData.elected_to}
                                onChange={(e) =>
                                    setFormData({ ...formData, elected_to: e.target.value })
                                }
                            >
                                <option value="">Select</option>
                                <option value="bat">Bat</option>
                                <option value="bowl">Bowl</option>
                            </select>
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary" onClick={() => setIsFormOpen(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-success" onClick={updateTossResult}>
                                Update Toss
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout >
    );
};

export default MatchStatusById;
